var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-editor-layer-header"},[_c('r-icon',{attrs:{"name":_vm.editorState.modelLayers.length ? 'model' : _vm.getGeomIcon(),"size":14}}),_c('r-text',[_vm._v("\n    "+_vm._s(_vm.editorState.name)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }